import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import spartaStoreUtility from "global/sparta-store-utility";

const EVENTS = {
  CREATE_EVENT: 'TRANSPORT.createdTransport',
  UPDATE_EVENT: 'TRANSPORT.updatedTransport',
  DELEGATE_EVENT: 'TRANSPORT.delegatedTransport',
  FETCH_EVENT: 'TRANSPORT.fetchedTransport',
  REFRESH_EVENT: 'TRANSPORT.refreshedTransport',
};

const _cachePathNamespace = 'transport-cache:';







function _cache(requestObj = {}) {
  const ttl = parseInt(requestObj.ttl, 10);
  const cacheKey = `${_cachePathNamespace}${requestObj.cachePath}`;
  const storageType = (ttl === 0) ? 'sessionStorage' : 'localStorage';

  (ttl === 1) && spartaStoreUtility.addData(cacheKey, requestObj) ||
    spartaStoreUtility.persist(cacheKey, requestObj, storageType);
}






function _getCachePath(method, url) {
  const path = url.match(/(?:https?:\/\/[^\/]*\/)(.*)/) || false;
  return (path ? `${method}.${path[1].replace('/', '.')}` : '');
}

class SpartaTransportUtility {
  get EVENTS() {
    return EVENTS;
  }






  isCached(requestObj = {}) {
    const cacheKey = _cachePathNamespace + requestObj.cachePath;
    let storedData = spartaStoreUtility.getData(cacheKey) ||
      spartaStoreUtility.getPersisted(cacheKey, 'sessionStorage');
    let result;

    storedData = Array.isArray(storedData) ? storedData[0] : storedData;

    if (!storedData) {
      return null;
    }


    if (storedData.ttl <= 1) {
      result = storedData;
    } else {
      const currentTime = Date.now();
      const cachedTime = storedData.timestamp;
      const diffTime = (currentTime - cachedTime) / 1000;


      result = diffTime < storedData.ttl ? storedData : null;
    }

    return result;
  }









  isPreloaded(requestObj = {}) {
    window.sparta = window.sparta || {};
    window.sparta.APIWorkers = window.sparta.APIWorkers || [];
    const workers = window.sparta.APIWorkers;

    return workers.some((item) => {
      if (requestObj.cachePath == item.key) {


        if (!item.data) {
          document.addEventListener(requestObj.cachePath + ':LOADED', (e) => {
            requestObj.subscription.success(item.data);
          }, false);
        } else {

          requestObj.subscription.success(item.data);
        }
        return true;
      }
    });
  }



















  subscribe(subscription = {}) {
    const {
      args,
      cache,
      contentType,
      crossDomain,
      dataType,
      error,
      headers,
      method,
      success,
      timeout,
      url,
      xhrFields,
      ignorePreload
    } = subscription;

    if (!url || !method || typeof success !== 'function' || typeof error !== 'function') {
      return false;
    }

    const requestObj = {
      cachePath: _getCachePath(method, url),
      subscription: subscription
    };

    const cachedData = this.isCached(requestObj);
    const preloaded = this.isPreloaded(requestObj);


    if (preloaded && !ignorePreload) {
      return false;
    }

    if (cachedData) {
      success(cachedData.data);
    } else {
      $.ajax({
        context: this,
        url,
        method,
        headers,
        dataType,
        contentType,
        crossDomain,
        xhrFields,
        timeout,
        data: args,
        success(data, status, jqXHR) {
          const ttl = jqXHR.getResponseHeader('ttl');
          Object.assign(requestObj, {
            data,
            ttl,
            timestamp: Date.now(),
          });

          if (parseInt(ttl, 10) >= 0 && cache !== false) { 
            _cache(requestObj);
          }

          success(data);
        },
        error(err) {
          error(err);
        },
      });
    }
  }



















  once(subscription = {}) {
    subscription.cache = false;
    return this.subscribe(subscription);
  }
}

export default new SpartaTransportUtility();
